import React from 'react';
import { createUseStyles } from 'react-jss';
import Loader from '@tcl-boron-prefabs/loader';
import { LoaderProps } from '@tcl-boron-prefabs/loader/lib/types';

export const LOADER_TEST_ID = 'loader-test-id';

const useStyles = createUseStyles({
  container: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    height: '100%',
  },
});

const LoadingIndicator: React.FunctionComponent<LoaderProps> = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Loader data-testid={LOADER_TEST_ID} {...props} />
    </div>
  );
};

export default LoadingIndicator;
